var _path, _circle, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60Z",
    fill: "url(#paint0_linear_104_11)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 60,
    cy: 60,
    r: 37.5,
    fill: "url(#paint1_linear_104_11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.192 59.8272L84.2423 55.4407L90.2758 58.365V74.1563L59.4378 89.9476L43.6836 82.3444V48.4224L52.3987 44.3283V77.0806L59.4378 80.2974L80.2199 69.185V63.3364L75.192 59.8272Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 75.3784V42.0413L60.838 26.25L87.6536 39.7018V49.6445L62.1788 62.5115V52.5688L77.933 44.6732L61.1732 36.7775L40.0559 47.0126V79.7649L30 75.3784Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1534 83.072C24.5714 83.072 23.2904 82.582 22.3104 81.602C21.3444 80.622 20.8614 79.355 20.8614 77.801V64.466C20.8614 64.074 20.7494 63.71 20.5254 63.374L18.7194 60.833C18.5094 60.525 18.4044 60.189 18.4044 59.825C18.4044 59.447 18.5094 59.111 18.7194 58.817L20.5254 56.276C20.7494 55.912 20.8614 55.548 20.8614 55.184V41.87C20.8614 40.302 21.3444 39.028 22.3104 38.048C23.2904 37.068 24.5714 36.578 26.1534 36.578H28.7784V40.148H26.3634C25.8314 40.148 25.3764 40.337 24.9984 40.715C24.6204 41.079 24.4314 41.534 24.4314 42.08V55.184C24.4314 56.332 24.0954 57.382 23.4234 58.334L22.3524 59.825L23.4234 61.316C24.0954 62.254 24.4314 63.304 24.4314 64.466V77.591C24.4314 78.123 24.6204 78.578 24.9984 78.956C25.3764 79.334 25.8314 79.523 26.3634 79.523H28.7784V83.072H26.1534ZM93.8387 83.072H91.2137V79.523H93.6287C94.1747 79.523 94.6297 79.334 94.9937 78.956C95.3717 78.578 95.5607 78.123 95.5607 77.591V64.466C95.5607 63.304 95.8967 62.254 96.5687 61.316L97.6397 59.825L96.5687 58.334C95.8967 57.382 95.5607 56.332 95.5607 55.184V42.08C95.5607 41.534 95.3717 41.079 94.9937 40.715C94.6297 40.337 94.1747 40.148 93.6287 40.148H91.2137V36.578H93.8387C95.4207 36.578 96.6947 37.068 97.6607 38.048C98.6407 39.028 99.1307 40.302 99.1307 41.87V55.184C99.1307 55.548 99.2427 55.912 99.4667 56.276L101.273 58.817C101.497 59.111 101.609 59.447 101.609 59.825C101.609 60.189 101.497 60.525 101.273 60.833L99.4667 63.374C99.2427 63.71 99.1307 64.074 99.1307 64.466V77.801C99.1307 79.355 98.6407 80.622 97.6607 81.602C96.6947 82.582 95.4207 83.072 93.8387 83.072Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_104_11",
    x1: -2.06277e-8,
    y1: 59.6407,
    x2: 123.922,
    y2: 56.5068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F285E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_104_11",
    x1: 22.5,
    y1: 60.0743,
    x2: 99.9513,
    y2: 57.8272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A52A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.214ae9790651ff795bbd36b6d1a95254.svg";
export { ForwardRef as ReactComponent };